import React from 'react';
import { Clock } from 'lucide-react';

/**
 * Indicador visual de vida útil de un equipo.
 * Verde: <2 años, Amarillo: 2-3 años, Rojo: >3 años
 */
function EquipmentLifeIndicator({ createdAt, compact = false }) {
  if (!createdAt) return null;

  const now = new Date();
  const created = new Date(createdAt);
  const diffMs = now - created;
  const years = diffMs / (1000 * 60 * 60 * 24 * 365.25);
  const months = Math.floor((years % 1) * 12);
  const fullYears = Math.floor(years);

  let color, bg, border, label;
  if (years < 2) {
    color = '#15803d';
    bg = '#f0fdf4';
    border = '#bbf7d0';
    label = 'Nuevo';
  } else if (years < 3) {
    color = '#a16207';
    bg = '#fefce8';
    border = '#fde68a';
    label = 'Medio';
  } else {
    color = '#dc2626';
    bg = '#fef2f2';
    border = '#fecaca';
    label = 'Antiguo';
  }

  const timeText = fullYears > 0
    ? `${fullYears}a ${months}m`
    : `${months}m`;

  const tooltip = `Registrado: ${created.toLocaleDateString('es-ES')} — ${fullYears} año${fullYears !== 1 ? 's' : ''} y ${months} mes${months !== 1 ? 'es' : ''}`;

  if (compact) {
    return (
      <span
        title={tooltip}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 3,
          fontSize: 11,
          fontWeight: 600,
          color,
          background: bg,
          border: `1px solid ${border}`,
          borderRadius: 6,
          padding: '2px 6px',
          cursor: 'default',
          whiteSpace: 'nowrap',
        }}
      >
        <Clock size={10} />
        {timeText}
      </span>
    );
  }

  return (
    <div
      title={tooltip}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        fontSize: 12,
        color,
        cursor: 'default',
      }}
    >
      <div style={{
        width: 8,
        height: 8,
        borderRadius: '50%',
        background: color,
        flexShrink: 0,
      }} />
      <span style={{ fontWeight: 600 }}>{timeText}</span>
      <span style={{ fontSize: 11, opacity: 0.7 }}>{label}</span>
    </div>
  );
}

export default EquipmentLifeIndicator;
